import script from "./MazdaInterfaceDocsPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./MazdaInterfaceDocsPanel.vue?vue&type=script&setup=true&lang=js"

import "./MazdaInterfaceDocsPanel.vue?vue&type=style&index=0&id=41dba294&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41dba294"]])

export default __exports__